<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import myHead from "./include/myhead";
import { localStorages } from "./api/storage/localStorage";
import { clearLoginInfoTimer } from "./api/utils";
export default {
  name: "App",
  provide () {
    return {
      reload: this.reload,
    };
  },
  components: { myHead },
  data () {
    return {
      routePath: null,
      isRouterAlive: true,
    };
  },
  watch: {
    $route (to, from) {
      this.routePath = this.$route.path;
    },
  },
  methods: {
    reload () {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
  mounted () {
    var _this = this;
    window.onbeforeunload = function () {
      /*关闭浏览器刷新时：取消判断是否在会中的计时*/
      // if(_this.$route.query.uid || _this.$store.state.user.uid){
      //   clearLoginInfoTimer(_this.$route.query.uid || _this.$store.state.user.uid);
      // }
    };
    // if(window && window.parent && window.parent.getLogedUserInfo){
    //   console.log(window.parent.getLogedUserInfo());
    // }
  },
  destroyed () { },
};
</script>
<style>
#app {
  font-family: Helvetica;
  -webkit-overflow-scrolling: touch;
  font-family: PingFang SC, Microsoft YaHei, SimHei, sans-serif;

  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
}
</style>
